import { render, staticRenderFns } from "./FrsFieldSelectionInfo.vue?vue&type=template&id=4d2c280c&scoped=true&"
import script from "./FrsFieldSelectionInfo.vue?vue&type=script&lang=js&"
export * from "./FrsFieldSelectionInfo.vue?vue&type=script&lang=js&"
import style0 from "./FrsFieldSelectionInfo.vue?vue&type=style&index=0&id=4d2c280c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2c280c",
  null
  
)

export default component.exports